export const setSessionStorage = (name, val) => {
  localStorage.setItem(name, JSON.stringify(val));
}
/*获取sessionStorage*/
export const getSessionStorage = (name) => {
  if(localStorage.hasOwnProperty(name)) {
      return JSON.parse(localStorage.getItem(name));
  } else {
      return false;
  }
}
/*删除sessionStorage*/
export const deleteSessionStorage = (name = null) => {
  if(name != null) {
    localStorage.removeItem(name);
  } else {
    localStorage.clear();
  }
}